import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputNumberComponent from '../components/inputs/InputNumberComponent';
import CardService from '../services/CardService';

class VisitLimitEditDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardService());

        this.state = {
            limit: this.props.limit ? this.props.limit : 0,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
        if (!prevProps.visible && this.props.visible) {
            this.setState({
                limit: this.props.limit ? this.props.limit : 0,
            });
        }
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton label={t('details.cancel')} variant={'button cancel-button white'} handleClick={this.props.onHide} />
                <ActionButton label={t('details.saveChanges')} variant='button save-button blue' handleClick={this.handleFormSubmit} />
            </div>
        );
    }
    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>{t('details.editButton')}</label>
                </DivContainer>
            </DivContainer>
        );
    }

    setElement() {
        this.initAfterSetElement();
    }
    getContainerListName() {
        return 'driver-list-container';
    }

    getUpdateSucces() {
        const {t} = this.props;
        return t('cards.visitLimitUpdateSuccess');
    }
    createOrUpdate() {
        const {limit} = this.state;
        this.scrollToTop();
        if (this.props._isMounted) {
            this.service
                .updateVisitLimit({dailyVisitLimit: limit, cards: this.props.cardNumbers})
                .then((response) => {
                    if (this.props.handleSuccess) {
                        this.unblockUi();
                        this.props.handleSuccess(response);
                    }
                })
                .catch((err) => {
                    if (this.props.handleError) {
                        this.unblockUi();
                        this.props.handleError();
                    }
                });
        }
    }

    renderDetails() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <div className='row profile'>
                    <InputNumberComponent
                        id={'limit'}
                        name={'limit'}
                        label={t('cards.dailyVisitLimit')}
                        value={this.state.limit}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        min={0}
                        inputStyle={{width: '100%'}}
                        colClass='col-12'
                        stateField=''
                    />
                </div>
            </React.Fragment>
        );
    }
}

VisitLimitEditDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'EDIT',
    visible: false,
};

VisitLimitEditDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    cardNumbers: PropTypes.array,
};

export default withTranslation()(VisitLimitEditDialog);
